/* Wild Ginga: show remaining edition stock per size when hovering a product card */
(function () {
  if (window.__stockHover) return;
  window.__stockHover = true;

  var css =
    '.stock-hover{position:absolute;left:0;right:0;bottom:0;z-index:3;pointer-events:none;' +
    'display:flex;flex-direction:column;gap:.2rem;padding:1rem 1.2rem;' +
    'background:rgba(0,0,0,.72);color:#fff;font-size:1.3rem;line-height:1.3;letter-spacing:.04rem;' +
    'opacity:0;transform:translateY(6px);transition:opacity .2s ease,transform .2s ease}' +
    '.stock-hover__title{font-size:1.1rem;text-transform:uppercase;letter-spacing:.12rem;opacity:.75;margin-bottom:.2rem}' +
    '.stock-hover__row{display:flex;justify-content:space-between;gap:1rem}' +
    '.stock-hover__row--out{opacity:.55;text-decoration:line-through}' +
    '.stock-hover-ready:hover .stock-hover,.stock-hover-ready:focus-within .stock-hover{opacity:1;transform:none}' +
    '@media (hover:none){.stock-hover{display:none}}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  var cache = {};
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function load(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root + 'products/' + handle + '?view=stock-json', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (t) { return t ? JSON.parse(t) : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  function attach(card) {
    if (card.dataset.stockHover) return;
    card.dataset.stockHover = '1';
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return;
    var m = link.getAttribute('href').match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var handle = m[1];
    var host = card.querySelector('.card__inner') || card;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var box = document.createElement('div');
    box.className = 'stock-hover';
    box.setAttribute('aria-hidden', 'true');
    host.appendChild(box);
    var started = false;
    function fill() {
      if (started) return;
      started = true;
      load(handle).then(function (d) {
        if (!d || !d.sizes || !d.sizes.length) { box.remove(); return; }
        var html = '<span class="stock-hover__title">Edition of ' + esc(d.edition) + ' per size</span>';
        d.sizes.forEach(function (s) {
          var out = s.remaining <= 0;
          html += '<span class="stock-hover__row' + (out ? ' stock-hover__row--out' : '') + '"><span>' + esc(s.name) +
            '</span><span>' + (out ? 'Sold out' : esc(s.remaining) + '/' + esc(d.edition)) + '</span></span>';
        });
        box.innerHTML = html;
        card.classList.add('stock-hover-ready');
      });
    }
    card.addEventListener('mouseenter', fill);
    card.addEventListener('focusin', fill);
  }

  function scan(scope) {
    (scope || document).querySelectorAll('.card-wrapper').forEach(attach);
  }

  function init() {
    scan();
    new MutationObserver(function () { scan(); }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
